import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';

import { registrarManagementOptions } from '../../schemas';

export function RegistrarManagementInput({ isEditable, className }: { isEditable?: boolean; className?: string }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="registrar_management"
      render={({ field }) => (
        <FormSelect
          value={field.value}
          onChange={field.onChange}
          disabled={!isEditable}
          label="Registrar Management"
          options={registrarManagementOptions}
          getOptionValue={(option) => option.value}
          getOptionLabel={(option) => option.name}
          formItemClassName={className}
        />
      )}
    />
  );
}
